import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, BrowserRouter, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./component/fontawesome/css/all.min.css"
// import "./component/font-awesome-4.7.0/css/font-awesome.css"
// import "./component/font-awesome-4.7.0/css/font-awesome.min.css"
import "./app.css"
import Login from "./pages/login/login";
import Home from "./pages/home/home";
import Leftmenu from "./leftmenu/leftmenu";
import AddRequest from "./pages/addrequest/addrequest";
import AddResurs from "./pages/addresurs/addresurs";
import TourDetails from "./pages/tourdetails/tourdetails";
import EditTour from "./pages/edittour/edittour";
import Orders from "./pages/orders/orders";
import Myorders from "./pages/myorders/myorders";
import Performers from "./pages/performers/performers";
import YurtCump from "./pages/yurtcump/yurtcump";
import GuestHouse from "./pages/guesthouse/guesthouse";
const API_URL = process.env.REACT_APP_API_URL ;
const RequireAccess = ({ user, allowedRoles = [], allowedSubroles = [], children }) => {
  if (!user) return <Navigate to="/" />;

  const role = (user.role || "").trim().toLowerCase();

  const subroles = (user.subroles || []).map(r =>
    r.trim().toLowerCase()
  );

  const hasRoleAccess = allowedRoles.map(r => r.toLowerCase()).includes(role);

  const hasSubroleAccess = allowedSubroles
    .map(r => r.toLowerCase())
    .some(r => subroles.includes(r));

  const hasAccess = hasRoleAccess || hasSubroleAccess;

  if (!hasAccess) {
    return <div style={{ padding: 20 }}>Нет прав доступа 🚫</div>;
  }

  return children;
};
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    setLoading(false);
  }, []);
  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  }
  if (loading) return null; // или spinner
  return (
    <>
      <ScrollToTop />
      <ToastContainer
        position="top-left"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick
      />
      <section className="app-screen">
        {user && <Leftmenu user={user} logout={logout} />}
        <Routes>
          <Route
            path="*"
            element={
              user
                ? <Navigate to="/home" />
                : <Navigate to="/" />
            }
          />
          <Route
            path="/"
            element={
              user
                ? <Navigate to="/home" />
                : <Login setUser={setUser} API_URL={API_URL} />
            }
          />
          <Route
            path="/home"
            element={
              user
                ? <Home user={user} logout={logout} API_URL={API_URL} />
                : <Navigate to="/" />
            }
          />
          <Route
            path="/tourdetails/:id"
            element={
              user
                ? <TourDetails user={user} logout={logout} API_URL={API_URL} />
                : <Navigate to="/" />
            }
          />

          <Route
            path="/addrequest"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin", "operator"]}
                  allowedSubroles={[]}
                >
                  <AddRequest API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/edittour/:id"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin", "operator"]}
                  allowedSubroles={[]}
                >
                  <EditTour API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/orders"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin"]}
                  allowedSubroles={[]}
                >
                  <Orders API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/myorders"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin", "operator"]}
                  allowedSubroles={[]}
                >
                  <Myorders API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/addresurs"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin"]}
                  allowedSubroles={["addCompanyandtours"]}
                >
                  <AddResurs API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/performers"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin", "mechanic", "operator"]}
                  allowedSubroles={[]}
                >
                  <Performers API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/yurtcump"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin", "operator"]}
                  allowedSubroles={["yurtcump"]}
                >
                  <YurtCump API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/guesthouse"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin", "operator"]}
                  allowedSubroles={["guesthouse"]}
                >
                  <GuestHouse API_URL={API_URL} user={user} />
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route
            path="/sedan"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin"]}
                  allowedSubroles={["sedan"]}
                >
                  <div>123</div>
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/minibus"
            element={
              user ? (
                <RequireAccess
                  user={user}
                  allowedRoles={["admin"]}
                  allowedSubroles={["minibus"]}
                >
                  <div>minibus</div>
                </RequireAccess>
              ) : (
                <Navigate to="/" />
              )
            }
          /> */}
        </Routes>
      </section>
    </>
  )
}
export default App;